import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Wrapper = styled.section`
  position: relative;
  width: 50%;
  float: left;
`

const BgImg = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  max-height: 105px;
  width: 12rem;
  min-height: 600px;
  z-index: -1;
  &.small {
    min-height: 100px;
  }

  height: 100%;
  & > img {
    object-fit: ${props => props.fit || 'cover'} !important;
    object-position: ${props => props.position || '50% 50%'} !important;
  }
`

class CompanyLogo extends React.Component {
    constructor(props) {
        super(props)
        this.state = { width: 0 }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    componentDidMount() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth })
    }

    render() {
        const {
            image,
            top
        } = this.props

        let isAndroidChrome = false
        if (typeof navigator !== 'undefined') {
            isAndroidChrome =
              navigator.appVersion.indexOf('Chrome/') !== -1
              &&
              (navigator.platform === 'Android' ||
                  navigator.platform.includes('Linux')) ||
                  navigator.platform === null
        }

        return (
            image &&
                <Wrapper className={this.props.className}>
                    <BgImg
                        className={top}
                        fluid={image.fluid}
                        backgroundColor={'#eeeeee'}
                        isAndroidChrome={isAndroidChrome}
                    />
                </Wrapper>
        )
    }
}

CompanyLogo.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    smallTitle: PropTypes.string,
    image: PropTypes.object,
    top: PropTypes.string
}


export default CompanyLogo
